import {ShoppingPathJointEventIO} from "../../io/content/shoppingPathJointEventIO";
import {EventType, PlaceEventType} from "../../constant/EventType";
import {PlacePathJointEventIO} from "../../io/content/place/PlacePathJointEventIO";


export const configureErrorTypeAndSetErrorPage =
    (   ErrorString: string,
        misc: string,
        updateCurrentPage: (page: string)=> void
    ) => {
        const regex = /userId=([^,]+), shoppingId=([^,]+), codeName=([^,]+)/
        const match = ErrorString.match(regex)

        let userId = null
        let shoppingId = null
        let errorType = null

        if (match) {
            userId= match[1]
            shoppingId= match[2]
            errorType= match[3]
        }

        if (errorType == "DAILY_PARTICIPATION_COUNT_LIMIT_EXCEEDED") {
            updateCurrentPage('ParticipationCntFullPage')
            ShoppingPathJointEventIO.post({
                shoppingPathJointId: null,
                userId: userId,
                misc: misc,
                eventType: EventType.ShoppingTodayParticipationLimitPageLanding
            }).then(
                v => console.log(v)
            ).catch(e => console.error(e))
        }else if(
            errorType == "SHOPPING_MISSION_EXHAUSTED" ||
            errorType == "Shopping_Mission_Keyword_NotFound" ||
            errorType == "Shopping_Mission_PathBrowser_NotFound"
        ){
            updateCurrentPage('ExhaustedPage');
            ShoppingPathJointEventIO.post({
                shoppingPathJointId: null,
                userId: userId,
                misc: misc,
                eventType: EventType.ShoppingExhaustedPageLanding
            }).then(
                v => console.log(v)
            ).catch(e => console.error(e))
        }else if(
            errorType == "TOTAL_AMOUNT_BELOW_THRESHOLD"
        ){
            updateCurrentPage('ThresholdPage');
            ShoppingPathJointEventIO.post({
                shoppingPathJointId: null,
                userId: userId,
                misc: misc,
                eventType: EventType.ShoppingExhaustedPageLanding
            }).then(
                v => console.log(v)
            ).catch(e => console.error(e))
        }
        else{
            updateCurrentPage('ErrorPage');
            ShoppingPathJointEventIO.post({
                shoppingPathJointId: null,
                userId: userId,
                misc: misc,
                eventType: EventType.ShoppingServerErrorPageLanding
            }).then(
                v => console.log(v)
            ).catch(e => console.error(e))
        }
    }

export const configurePlaceErrorTypeAndSetErrorPage =
    (   ErrorString: string,
        misc: string,
        updateCurrentPage: (page: string)=> void
    ) => {
        const regex = /userId=([^,]+), placeId=([^,]+), codeName=([^,]+)/
        const match = ErrorString.match(regex)

        let userId = null
        let placeId = null
        let errorType = null

        if (match) {
            userId= match[1]
            placeId= match[2]
            errorType= match[3]
        }

        if (errorType == "DAILY_PARTICIPATION_COUNT_LIMIT_EXCEEDED") {
            updateCurrentPage('ParticipationCntFullPage')
            PlacePathJointEventIO.post({
                placePathJointId: null,
                userId: userId,
                misc: misc,
                eventType: PlaceEventType.PlaceTodayParticipationLimitPageLanding
            }).then(
                v => console.log(v)
            ).catch(e => console.error(e))
        }else if(
            errorType == "PLACE_MISSION_EXHAUSTED" ||
            errorType == "PLACE_Mission_Keyword_NotFound" ||
            errorType == "PLACE_Mission_PathBrowser_NotFound"
        ){
            updateCurrentPage('ExhaustedPage');
            PlacePathJointEventIO.post({
                placePathJointId: null,
                userId: userId,
                misc: misc,
                eventType: PlaceEventType.PlaceExhaustedPageLanding
            }).then(
                v => console.log(v)
            ).catch(e => console.error(e))
        }
        else{
            updateCurrentPage('ErrorPage');
            PlacePathJointEventIO.post({
                placePathJointId: null,
                userId: userId,
                misc: misc,
                eventType: PlaceEventType.PlaceServiceErrorPageLanding
            }).then(
                v => console.log(v)
            ).catch(e => console.error(e))
        }
    }